import { MolsonTypography } from '@components/reusable'
import type { TypographyProps } from '@mui/material'

type TypographyWithClampingProps = {
  lineClampNr?: number
  labelToClamp: string
} & TypographyProps

export const TypographyWithClamping = ({
  lineClampNr = 2,
  labelToClamp,
  ...props
}: TypographyWithClampingProps) => (
  <MolsonTypography
    sx={{
      whiteSpace: 'break-spaces',
      display: '-webkit-box',
      // biome-ignore lint/style/useNamingConvention: <explanation>
      WebkitLineClamp: lineClampNr,
      // biome-ignore lint/style/useNamingConvention: <explanation>
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }}
    {...props}
  >
    {labelToClamp}
  </MolsonTypography>
)
